<template>
    <div class="assignment-color-list-example">
        <div class="list-items">
            <div
                class="color-list-item"
                v-for="item in partIn.list_items"
                :key="item.id">
                <div class="list-item-header">
                    <design-2021-lesson-module-assignment-type-assignment-part-list-item-component
                        @list-item-updated="updateListItem"
                        :item-in="item">
                    </design-2021-lesson-module-assignment-type-assignment-part-list-item-component>
                </div>

                <div class="answers">
                    <design-2021-assignment-edit-type-assignment-part-color-select-list-component
                        :options-in="colorOptions"
                        :id="`colorlist-faq-${item.id}`">
                    </design-2021-assignment-edit-type-assignment-part-color-select-list-component>

                    <b-button
                        class="btn-remove btn-remove-question"
                        variant="danger-icon-only"
                        :disabled="partIn.list_items.length === 1"
                        @click="deleteItem(item)">
                    </b-button>
                </div>
            </div>
        </div>

        <div class="new-list">
            <design-2021-lesson-module-assignment-type-assignment-part-list-question-component
                @list-item-added="addListItem"
                :part-in="partIn">
            </design-2021-lesson-module-assignment-type-assignment-part-list-question-component>

            <div class="add-answer">
                <b-button
                    class="btn-edit btn-new-answer-option"
                    v-b-modal="'assignment-edit-part-colorlist-options-modal-' + partIn.id"
                    variant="primary"
                    @click="showEditModal()">
                    {{ $t('assignment.edit_answer_options') }}
                </b-button>
            </div>
        </div>

        <design-2021-lesson-module-assignment-part-colorlist-options-modal-component
            @part-updated="updatePart"
            :part-in="partIn">
        </design-2021-lesson-module-assignment-part-colorlist-options-modal-component>
    </div>
</template>

<script>
import { CommonBus } from '../../../../../../../app';

export default {
    name: 'design-2021-lesson-module-assignment-type-assignment-part-colorlist-component',
    props: {
        partIn: Object,
    },
    methods: {
        getColorName: function (color) {
            if (color === '#f35958') {
                return 'Rood';
            } else if (color === '#0acf97') {
                return 'Groen';
            } else if (color === '#ffb548') {
                return 'Oranje';
            } else if (color === '#007bff') {
                return 'Blauw';
            } else if (color === 'Kies een kleur') {
                return 'Kies een kleur';
            } else {
                return 'Onbekend';
            }
        },

        updateListItem(newItem) {
            let part = this.partIn;
            part.list_items = part.list_items.map((item) => {
                if (item.id === newItem.id) {
                    return newItem;
                }
                return item;
            });

            this.updatePart(part);
        },
        addListItem(newItem) {
            let part = this.partIn;
            part.list_items.push(newItem);

            this.updatePart(part);
        },
        updatePart(newPart) {
            this.$emit('part-updated', newPart);
        },

        showEditModal() {
            this.$bvModal.show(`edit-assignment-part-colorlist-modal-${this.partIn.id}`);
        },

        removePart() {
            this.$emit('call-remove-part', this.partIn.id);
        },

        deleteItem(item) {
            this.$emit('call-delete-item', item);
        },

        updateQuestionTitle(value, item) {
            this.$emit('call-update-item', value, item);
        },

        editQuestion() {
            CommonBus.$emit('enable-edit-mode');
        },
    },

    computed: {
        colorOptions() {
            let options = [];
            for (const colorOption of this.partIn.list_options) {
                options.push({
                    id: colorOption.id,
                    name: this.getColorName(colorOption.value),
                    value: colorOption.value,
                });
            }
            return options;
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .apprentice-multiselect {
    .multiselect__tags {
        height: 51px;
    }
}

.assignment-color-list-example {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    row-gap: $grid-gutter-width;
}

.list-items {
    .color-list-item ::v-deep {
        display: flex;
        flex: 1 0;
        flex-direction: column;
        gap: map-get($grid-gutter-spacing, 'eight') $grid-gutter-width;

        .dropdown-toggle {
            margin-left: auto;
            width: auto;
            align-self: baseline;
            margin-right: auto;
            text-align: left;
            min-width: 160px;
        }

        .dropdown-menu {
            width: 100%;
        }
    }

    .list-item-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
    }

    .btn-remove-question {
        align-self: center;
        font-size: 1.3125rem;

        &:before,
        &:after {
            align-self: center;
        }
    }
}

.new-list {
    display: flex;
    flex-direction: column;

    .btn-new-answer-option {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.answers ::v-deep {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    > div {
        width: 100%;
    }

    .multiselect__select {
        &:before {
            display: inline;
            top: 65%;
        }
    }

    .multiselect__tags {
        .multiselect__single {
            min-height: 10px;
            line-height: 1;
            vertical-align: middle;

            .label {
                margin-bottom: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .list-items {
        .color-list-item {
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: flex-start;

            .list-item-header {
                align-self: center;
            }

            .list-item-header,
            .answers {
                flex: 1 0 100%;
            }

            .answers {
                display: flex;
                flex-direction: row;

                .colorlist-faq-dropdown {
                    align-self: center;
                }
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .new-list {
        flex-direction: column;
        justify-content: flex-start;
        gap: map-get($grid-gutter-spacing, 'fifteen') $grid-gutter-width;

        .new-question,
        .btn-new-answer-option {
            width: auto;
        }

        .btn-new-answer-option {
            margin-top: 0;
            align-self: flex-start;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .list-items {
        .color-list-item {
            .list-item-header {
                flex: 0 0 auto;
                width: calc(50% - 42px);
            }

            .answers {
                flex: 0 0 auto;
            }
        }
    }

    .assignment-color-list-example {
        flex-wrap: nowrap;
    }

    .new-list {
        flex-direction: row;
        justify-content: flex-start;

        .new-question {
            width: calc(50% - 42px);
        }

        .add-answer {
            width: calc(50% - 15px);
            align-self: flex-end;
        }

        .btn-new-answer-option {
            width: auto;
        }
    }

    .answers ::v-deep {
        .multiselect {
            width: 225px;
        }
    }
}
</style>
